module.exports={"error-screen":{"not-found":"L'écran recherché n'existe pas !"}};